<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1>添加学生</h1>
        <span class="pull-right icon-right orange" @click="addStudent()">提交</span>
      </div>
      <div class="liner"></div>
    </div>

    <div class="main-page">
      <div>
        <!--王备写的-->
        <p class="margin-15">红色“*”为必填项，请认真填写。</p>
        <ul class="list-group-item tinny">
          <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix upload-head upload-pic">
              <form enctype="multipart/form-data" method="post" name="fileinfo">
                <span class="pull-left">上传头像</span>
                <span class="pull-right"><img :src="imageAddress ? baseAcessPath + imageAddress : img_default" width="60" height="60"></span>
                <span class="upload-wrap" @click="capturePhoto();" v-if="isAndroid"></span>
                <span class="upload-wrap" v-else><input type="file" name="pic" id="pic" accept="image/*" size="1" @change="updateImage()"/></span>
              </form>
            </div>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix  group-txt">
              <span class="pull-left">学生姓名：</span><i class="red must">*</i>
              <span class="pull-right gray"><input class="text-right font-14" type="text" placeholder="请输入学生姓名" v-model="studentName"></span>
            </div>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix  group-txt">
              <span class="pull-left">性别：</span><i class="red must">*</i>
              <span class="pull-right clearfix checkbox-group">
                <cite class="pull-right img-checkbox" v-bind:class="{'checked': sex == '女'}" @click="sex = '女'">女</cite>
                <cite class="pull-right img-checkbox" v-bind:class="{'checked': sex == '男'}" @click="sex = '男'">男</cite>
              </span>
            </div>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix group-txt img-more" @click="openPicker('picker')">
              <span class="pull-left">出生年月：</span>
              <span class="pull-right margin-x-15 gray font-12">{{birthday ? birthday : '请选择'}}</span>
            </div>
          </li>
        </ul>

        <ul class="list-group-item tinny hide">
          <li class="list-group">
            <div class="liner"></div>
            <a class="clearfix group-txt img-more" @click.prevent="getCurcheClassList()">
              <span class="pull-left">编入班级：</span>
              <span class="pull-right margin-x-15 gray font-12">{{curcheClassName}}</span>
            </a>
          </li>
        </ul>

        <ul class="list-group-item tinny">
          <li class="list-group">
            <div class="liner"></div>
            <a class="clearfix group-txt img-more" @click.prevent="getCurcheServiceList()">
              <span class="pull-left">托管服务：</span>
              <span class="pull-right margin-x-15 gray font-12">{{curcheServiceName}}</span>
            </a>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <a class="clearfix group-txt">
              <span class="pull-left">所在学校：</span>
              <span class="pull-right gray"><input class="text-right font-14" type="text" placeholder="请输入" v-model="szxx"></span>
            </a>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <a class="clearfix group-txt img-more" @click.prevent="isHideSchoolGrade = false">
              <span class="pull-left">年级：</span>
              <span class="pull-right margin-x-15 gray font-12">{{grade ? grade : '请选择'}}</span>
            </a>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <a class="clearfix group-txt img-more" @click.prevent="isHideSchoolClass = false">
              <span class="pull-left">班级：</span>
              <span class="pull-right margin-x-15 gray font-12">{{className ? className + '班' : '请选择'}}</span>
            </a>
          </li>
        </ul>

        <span class="block margin-x-15 gray">家长信息</span>
        <ul class="list-group-item tinny">
          <li class="list-group">
            <div class="liner"></div>
            <a class="clearfix group-txt img-more" @click.prevent="isHideParentRole = false">
              <span class="pull-left">监护角色：</span><i class="red must">*</i>
              <span class="pull-right gray margin-x-15 font-12">{{parentRole ? parentRole : '请选择'}}</span>
            </a>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix group-txt">
              <span class="pull-left">手机号码：</span><i class="red must">*</i>
              <span class="pull-right gray"><input class="text-right font-14" type="number" placeholder="请输入手机号码" v-model="parentPhone"></span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="maskdiv" v-show="!isHideSetCurcheServiceDialog">
      <div class="popover">
        <div class="pop-wrap text-center">
          <p v-if="cookie_login_data.jobId == 1 || cookie_login_data.jobId == 2">该园点还未设置托管服务，请到“园点管理”处设置。</p>
          <p v-else>该园点还未设置托管服务，请联系管理员到“园点管理”处设置。</p>
          <div class="liner margin-15"></div>
          <div class="clearfix" v-if="cookie_login_data.jobId == 1 || cookie_login_data.jobId == 2">
            <div class="col-xs-6 blue"><router-link hre="javascript:;" class="blue  block" style="border-right:1px solid #ddd;" :to="{'path': '/curche/edit'}">去设置</router-link></div>
            <div class="col-xs-6 blue"><a hre="javascript:;" class="blue" @click="isHideSetCurcheServiceDialog = true">以后再说</a></div>
          </div>
          <div class="clearfix" v-else>
            <div class="col-xs-12 blue"><a hre="javascript:;" class="blue" @click="isHideSetCurcheServiceDialog = true">以后再说</a></div>
          </div>
        </div>
      </div>
    </div>

    <mt-popup 
    v-model="popupVisebleTips" 
    position="bottom">
    <div>
      <div class="padding-15">
        <p class="font-16 margin-15">温馨提示</p>
        <p class="font-12 margin-15 gray">手动添加的家长手机号为 <span class="orange">“未激活”</span> 状态，不能作为家长的登录账号，如果要为家长开通，请发邀请给家长申请开通哦！</p>
      </div>
      <div class="liner"></div>
      <span class="block text-center padding-15" @click="popupVisebleTips = false">我知道了</span>
    </div>
    </mt-popup>

      <!-- 关联服务 -->
    <div class="maskdiv" v-show="!isHideCurcheService" @click="isHideCurcheService = true">
      <div class="slider" @click.stop>
        <strong class="tit">关联服务</strong>
        <div class="liner"></div>
        <div class="list-group-item tinny">
          <ul v-for="item in curcheServiceList">
            <li @click="csId = item.csId, isHideCurcheService = true, curcheServiceName = item.serviceName + ' ' + item.currentServiceFee + '元/月'">
              <div class="clearfix group-link"><span class="pull-left">{{item.serviceName}} {{item.currentServiceFee}}元/月</span>
              <template v-if="item.csId == csId">
                <i class="pull-right img-checkbox checked"></i>
              </template>
              <template v-else>
                <i class="pull-right img-checkbox"></i>
              </template>
              </div>
              <div class="liner"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>

      <!-- 关联班级 -->
    <div class="maskdiv" v-show="!isHideCurcheClass" @click="isHideCurcheClass = true">
      <div class="slider" @click.stop>
        <strong class="tit">编入班级</strong>
        <div class="liner"></div>
        <div class="list-group-item tinny">
          <ul v-for="item in curcheClassList">
            <li @click="classId = item.classId, curcheClassName = item.className, isHideCurcheClass = true">
              <div class="clearfix group-link"><span class="pull-left">{{item.className}}</span>
              <template v-if="item.classId == classId">
                <i class="pull-right img-checkbox checked"></i>
              </template>
              <template v-else>
                <i class="pull-right img-checkbox"></i>
              </template>
              </div>
              <div class="liner"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>

      <!-- 关联学校年级 -->
    <div class="maskdiv" v-show="!isHideSchoolGrade" @click="isHideSchoolGrade = true">
      <div class="slider" @click.stop>
        <strong class="tit">选择年级</strong>
        <div class="liner"></div>
        <div class="list-group-item tinny">
          <ul v-for="item in gradeList">
            <li @click="grade = item, isHideSchoolGrade = true">
              <div class="clearfix group-link"><span class="pull-left">{{item}}</span>
              <template v-if="item == grade">
                <i class="pull-right img-checkbox checked"></i>
              </template>
              <template v-else>
                <i class="pull-right img-checkbox"></i>
              </template>
              </div>
              <div class="liner"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>

      <!-- 关联学校班级 -->
    <div class="maskdiv" v-show="!isHideSchoolClass" @click="isHideSchoolClass = true">
      <div class="slider" @click.stop>
        <strong class="tit">选择班级</strong>
        <div class="liner"></div>
        <div class="list-group-item tinny">
          <ul v-for="item in 20">
            <li @click="className = (item + 1), isHideSchoolClass = true">
              <div class="clearfix group-link"><span class="pull-left">{{item + 1}}班</span>
              <template v-if="item + 1 == className">
                <i class="pull-right img-checkbox checked"></i>
              </template>
              <template v-else>
                <i class="pull-right img-checkbox"></i>
              </template>
              </div>
              <div class="liner"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>

      <!-- 关联家长 -->
      <!-- 关联监护角色 -->
    <div class="maskdiv" v-show="!isHideParentRole" @click="isHideParentRole = true">
      <div class="slider" @click.stop>
        <strong class="tit">监护角色</strong>
        <div class="liner"></div>
        <div class="list-group-item tinny">
          <ul v-for="item in parentRoleList">
            <li @click="parentRole = item, isHideParentRole = true">
              <div class="clearfix group-link"><span class="pull-left">{{item}}</span>
              <template v-if="item == parentRole">
                <i class="pull-right img-checkbox checked"></i>
              </template>
              <template v-else>
                <i class="pull-right img-checkbox"></i>
              </template>
              </div>
              <div class="liner"></div>
            </li>
          </ul>
        </div>
      </div>

    </div>

    <mt-datetime-picker type="date" year-format="{value} 年" ref="picker"
        month-format="{value} 月" date-format="{value} 日" @confirm="handleChange" :start-date="pickerStartDate" :end-date="pickerEndDate">
    </mt-datetime-picker>
  </div>
</template>

<script>
var startDate = new Date()
startDate.setFullYear(startDate.getFullYear() - 20)
import { service, uploadUrl } from '../../service'
import { Toast, Indicator } from 'mint-ui'
import { mapMutations } from 'vuex'

export default {
  data () {
    return {
      img_default: require('../../assets/images/img-default.png'),
      login_data: JSON.parse(window.localStorage['login_data']),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      add_student_para: service.setPara('addStudent'),
      get_curche_class_para: service.setPara('getClassList'),
      get_curche_service_para: service.setPara('getCurcheServicelist'),
      isHideSetCurcheServiceDialog: true, // 是否隐藏设置园点服务弹出框
      isHideCurcheService: true, // 是否隐藏园点服务选择
      isHideCurcheClass: true, // 是否隐藏园点班级选择
      isHideSchoolGrade: true, // 是否隐藏学校年级选择
      isHideSchoolClass: true, // 是否隐藏学校班级
      isHideParentRole: true, // 是否隐藏家长角色
      curcheId: 0,
      curcheName: '',
      imageAddress: '',
      studentName: '',
      sex: '男',
      birthday: '',
      classId: '', // 编入园点班级
      csId: '', // 园点服务id
      className: '', // 学校班级名称
      grade: '', // 学校年级
      szxx: '', // 园点地址
      // 关联家长
      parentRoleList: ['爸爸', '妈妈', '爷爷', '奶奶', '哥哥', '姐姐', '外公', '外婆', '叔叔', '阿姨', '家教', '其他'],

      // 家长信息 开始
      parentRole: '',
      parentPhone: '',
      editParentIndex: 0, // 要删除家长的下标
      curcheServiceList: [],
      curcheClassList: [],
      curcheServiceName: '请选择托管服务',
      curcheClassName: '请选择班级',
      gradeList: ['一年级', '二年级', '三年级', '四年级', '五年级', '六年级', '初中一年级', '初中二年级', '初中三年级'],
      baseAcessPath: '',
      isAndroid: true,
      pickerVisible: false,
      pickerStartDate: startDate,
      pickerEndDate: new Date(),
      popupVisebleTips: false
    }
  },
  mounted: function () {
    let b = window.browser()
    this.isAndroid = b.android
    this.init()
    this.popupVisebleTips = true
  },
  methods: {
    ...mapMutations([
      'clearStudents',
      'clearStudentParents'
    ]),
    openPicker (picker) {
      this.$refs[picker].open()
    },
    handleChange: function (value) {
      this.birthday = value.format('yyyy-MM-dd')
    },
    init: function () {
      this.curcheId = this.cookie_login_data.curcheId
      this.curcheName = this.login_data[this.cookie_login_data.index].curcheName
      this.szxx = this.cookie_login_data.serviceSchool ? this.cookie_login_data.serviceSchool : ''
    },
    getCurcheServiceList: function () {
      if (this.curcheServiceList.length > 0) {
        this.isHideCurcheService = false
        return
      }
      this.get_curche_service_para.curcheId = this.curcheId

      let that = this
      let obj = {context: this, para: this.get_curche_service_para, successFun: (response) => {
        that.curcheServiceList = response.data
        if (that.curcheServiceList.length > 0) {
          that.csId = that.curcheServiceList[0].csId
          that.isHideCurcheService = false
        } else {
          that.isHideSetCurcheServiceDialog = false
        }
      }}
      service.request(obj)
    },
    getCurcheClassList: function () {
      if (this.curcheClassList.length > 0) {
        this.isHideCurcheClass = false
        return
      }
      this.get_curche_class_para.curcheId = this.curcheId

      let that = this
      let obj = {context: this, para: this.get_curche_class_para, successFun: (response) => {
        that.curcheClassList = response.data
        if (that.curcheClassList.length > 0) {
          // this.csId = this.curcheClassList[0].csId
          that.isHideCurcheClass = false
        }
      }}
      service.request(obj)
    },
    addStudent: function () {
      if ($.trim(this.studentName) === '') {
        Toast('请输入姓名')
        return
      }

      if ($.trim(this.parentRole) === '') {
        Toast('请选择家长角色')
        return
      }
      var reg = /^1\d{10}$/
      if (!reg.exec($.trim(this.parentPhone))) {
        Toast('请输入正确的手机号')
        return
      }
      this.add_student_para.curcheId = this.curcheId
      this.add_student_para.curcheName = this.curcheName
      this.add_student_para.imageAddress = this.imageAddress
      this.add_student_para.studentName = $.trim(this.studentName)
      this.add_student_para.sex = this.sex
      this.add_student_para.birthday = this.birthday
      this.add_student_para.classId = this.classId
      this.add_student_para.csId = this.csId
      this.add_student_para.className = this.className ? this.className + '班' : ''
      this.add_student_para.grade = this.grade
      this.add_student_para.szxx = this.szxx
      this.add_student_para.parentRole = this.parentRole
      this.add_student_para.parentPhone = this.parentPhone

      let obj = {context: this, para: this.add_student_para, successFun: (response) => {
        this.$store.dispatch('clearStudents')
        this.$store.dispatch('clearStudentParents')
        window.history.go(-2)
      }, not100CodeFun: (response) => {
        if (response.code === '106') {
          Toast('该学生已存在，无须重复添加')
        } else {
          Toast(response.msg)
        }
      }}
      service.request(obj)
    },
    updateImage: function () {
      let that = this
      if (document.getElementById('pic').files.length === 0) {
        return
      }

      lrz(document.getElementById('pic').files[0], {width: 100})
        .then(function (rst) {
          var data = new window.FormData()
          data.append('pic', rst.file, rst.origin.name)
          let url = uploadUrl + that.cookie_login_data.phoneNum + '&needThumb=1'

          let obj = {context: that, para: data, url: url, successFun: (response) => {
            that.baseAcessPath = response.data.baseAcessPath
            that.imageAddress = response.data.thumbFilePath
          }}
          service.request(obj)
        })
    },
    capturePhoto: function () {
      Indicator.open()
      navigator.camera.getPicture(this.onPhotoDataSuccess, this.onFail, { quality: 80, destinationType: navigator.camera.DestinationType.DATA_URL, sourceType: navigator.camera.PictureSourceType.PHOTOLIBRARY, targetWidth: 200, targetHeight: 200 })
    },
    onPhotoDataSuccess: function (imageData) {
      let imgData = 'data:image/jpeg;base64,' + imageData
      let f = {}
      f.file = this.dataURLtoBlob(imgData)
      f.name = '0.png'

      var data = new window.FormData()
      data.append('pic', f.file, f.name)
      let url = uploadUrl + this.cookie_login_data.phoneNum + '&needThumb=1'
      let obj = {context: this, para: data, url: url, successFun: (response) => {
        this.baseAcessPath = response.data.baseAcessPath
        this.imageAddress = response.data.thumbFilePath
        Indicator.close()
      }}
      service.request(obj)
    },
    onFail: function (message) {
      Indicator.close()
      // alert('Failed because: ' + message)
    },
    dataURLtoBlob: function (dataurl) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = window.atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new window.Blob([u8arr], {type: mime})
    }
  }
}
</script>



// WEBPACK FOOTER //
// StudentAdd.vue?69fb210e